import Component from '../abstracts/Component';
import RegisterLogic from '../logics/RegisterLogic';

export default class GuestRegistrationComponent extends Component {

  static get SELECTORS() {
    return {
      radioProfilingSelector: ".js-radiobutton-profiling",
      radioNewsletterSelector: ".js-radiobutton-newsletter",
      radioProfilingContent: ".js-content-profiling",
      radioNewsletterContent: ".js-content-newsletter",
      buttonSelector: ".js-button-submit",
    };
  }

  static clickRadioEvent($clickedElem) {
    let $clickedElemParent = $clickedElem.parent();
    let $container = $clickedElem.parent().parent();

    $container.find("input.selected").attr("checked", false);
    $container.find("label").removeClass("selected");
    $container.find("input.selected").removeClass("selected");

    $clickedElemParent.addClass("selected");
    $clickedElem.addClass("selected");
    $clickedElem.attr('checked', true);
  }

  clickRadioProfiling() {
    GuestRegistrationComponent.clickRadioEvent($(this));
    $(`${GuestRegistrationComponent.SELECTORS.radioNewsletterSelector}`).attr('disabled', false);
    $(`${GuestRegistrationComponent.SELECTORS.radioNewsletterContent}`).removeClass('disable-step');
  }

  clickRadioNewsletter() {
    GuestRegistrationComponent.clickRadioEvent($(this));
    $(`${GuestRegistrationComponent.SELECTORS.buttonSelector}`).removeAttr('disabled');
  }

  render() {
    super.render();

    this.RegisterLogic = new RegisterLogic(this);
    this.RegisterLogic.render();

    this.bindClickPrivacy();
    this.bindClickRadioProfiling();
    this.bindClickRadioNewsletter();

  }

  bindClickRadioProfiling() {
    this.log("Binding click on radio profiling");
    $(document).on(
      'click',
      `${GuestRegistrationComponent.SELECTORS.radioProfilingSelector}`,
      {},
      this.clickRadioProfiling
    );
  }

  bindClickRadioNewsletter() {
    this.log("Binding click on radio newsletter");
    $(document).on(
      'click',
      `${GuestRegistrationComponent.SELECTORS.radioNewsletterSelector}`,
      {},
      this.clickRadioNewsletter
    );
  }

  bindClickPrivacy() {
    $('body').on('change.mmfg', '.js-register-privacy', function () {
      if ($(this).is(':checked')) {
        $('.js-radiobutton-profiling').attr('disabled', false);
        $('.js-content-profiling').removeClass('disable-step');
      } else {
        $('.js-radiobutton-profiling').prop('checked', false);
        $('.js-radiobutton-newsletter').prop('checked', false);
        $('.js-radiobutton-profiling').attr('disabled', true);
        $('.js-radiobutton-newsletter').attr('disabled', true);
        $('.js-privacy-alert').removeClass('d-none').addClass('d-none');
        $('.js-content-profiling').addClass('disable-step');
        $('.js-content-newsletter').addClass('disable-step');
        $('.js-button-submit').attr('disabled', true);
      }
    });
    //$('.js-button-submit').attr('disabled', true);
  }

}
